import { createFileRoute } from "@tanstack/react-router"
import { CheckCircle, Loader2, XCircle } from "lucide-react"
import { useEffect, useState } from "react"

import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "@/components/ui/card"
import { publicUnsubscribe } from "@/http/changelog/public"

export const Route = createFileRoute(
  "/changelog/unsubscribe/$token",
)({
  component: UnsubscribePage,
})

function UnsubscribePage() {
  const { token } = Route.useParams()
  const [status, setStatus] = useState<
    "loading" | "success" | "error"
  >("loading")

  useEffect(() => {
    let cancelled = false
    setStatus("loading")

    publicUnsubscribe(token)
      .then(() => {
        if (!cancelled) setStatus("success")
      })
      .catch(() => {
        if (!cancelled) setStatus("error")
      })

    return () => {
      cancelled = true
    }
  }, [token])

  return (
    <div className="flex min-h-svh items-center justify-center px-4">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          {status === "loading" && (
            <Loader2 className="text-muted-foreground mx-auto size-10 animate-spin" />
          )}
          {status === "success" && (
            <CheckCircle className="mx-auto size-10 text-emerald-500 dark:text-emerald-400" />
          )}
          {status === "error" && (
            <XCircle className="mx-auto size-10 text-destructive" />
          )}
          <CardTitle className="mt-4">
            {status === "loading" && "Cancelando inscrição..."}
            {status === "success" && "Inscrição cancelada"}
            {status === "error" && "Link inválido ou expirado"}
          </CardTitle>
        </CardHeader>
        <CardContent className="text-muted-foreground text-center">
          {status === "success" &&
            "Você não receberá mais notificações deste changelog."}
          {status === "error" &&
            "O link pode ter expirado ou já foi utilizado."}
        </CardContent>
      </Card>
    </div>
  )
}
